import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { markdownComponents } from '@/config/markdownConfig'
import { useTranslation } from 'react-i18next'
import type { UserArtifactModel } from './userArtifact'

interface AiSummaryPaneProps {
  model: UserArtifactModel
}

/** "AI Summary" tab body (FS-557 Phase 1): the AI-generated summary markdown. */
export function AiSummaryPane({ model }: AiSummaryPaneProps) {
  const { t } = useTranslation('document_viewer')

  return (
    <div className="h-full overflow-auto px-6 py-4">
      {model.summary ? (
        <div className="prose prose-sm dark:prose-invert max-w-none">
          {/* remarkGfm only — matches the ReviewTab/ExtractionsTab usage of
              markdownComponents; transcript summaries are prose with no math. */}
          <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
            {model.summary}
          </ReactMarkdown>
        </div>
      ) : (
        <p className="text-sm text-gray-500 dark:text-dark-text-muted">
          {t('user_artifact.noSummary', { defaultValue: 'No summary available for this call.' })}
        </p>
      )}
    </div>
  )
}

export default AiSummaryPane
